<div id="third-party-cookies-error" class="flex flex-1 min-h-full flex-col" aria-labelledby="cookies-required-title">

    <div class="flex justify-center mt-fdk-xxxl">
    <fdk-illustration name="warning" />
  </div>

    <h2 id="cookies-required-title" class="fdk-type-heading-2 text-fdk-primary text-center mt-fdk-m">
      Third-party cookies are required
    </h2>
    <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
      Third-party cookies must be enabled to complete the auth flow.
    </p>

  <div *ngIf="!requiresSafariOnIos" id="browser-cookie-instructions" class="mt-fdk-xs fdk-type-paragraph text-fdk-secondary ">
    <p class="text-fdk-secondary">
      Open your browser's privacy or cookie settings and allow third-party cookies for this application. Then return and
      try signing in again.
    </p>
    <fdk-link *ngIf="thirdPartyCookieDocumentationLink as documentationLink"
       id="third-party-cookie-documentation-link"
       [href]="documentationLink.url" target="_blank" rel="noopener noreferrer">
      View {{ documentationLink.browserName }} cookie instructions
    </fdk-link>
  </div>

  <div *ngIf="requiresSafariOnIos" id="ios-safari-required" class="mt-fdk-xs fdk-type-paragraph text-fdk-secondary ">
    <p class="text-fdk-secondary">
      Safari is currently required on iPhone and iPad. Other browsers on iOS are not currently supported.
    </p>
    <fdk-link *ngIf="safariDeepLink" id="open-in-safari-link" [href]="safariDeepLink" target="_top">
      Open in Safari
    </fdk-link>
    <p class="mt-2">
      If Safari does not open, copy this page's address and paste it into Safari.
    </p>
  </div>

  <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-m">
    If this issue continues, please
    <fdk-link id="cookie-support-link" routerLink="/form/support">contact support</fdk-link>.
  </p>

  <div *ngIf="showCookieDebugInfo && cookieDebugInfo as debugInfo" id="cookie-debug-info"
       class="mt-fdk-m mb-fdk-m">
    <h3 class="fdk-type-heading-4 text-fdk-secondary">Session debug information (test mode)</h3>
    <dl class="mt-3 grid grid-cols-[auto,minmax(0,1fr)] gap-x-4 gap-y-2 text-sm">
      <dt class="fdk-type-label-small text-fdk-secondary">Cookie name</dt>
      <dd class="fdk-type-paragraph-s text-fdk-secondary">{{ debugInfo.cookieName }}</dd>

      <dt class="fdk-type-label-small text-fdk-secondary">Session active</dt>
      <dd class="fdk-type-paragraph-s text-fdk-secondary">{{ debugInfo.isSet ? 'Yes' : 'No' }}</dd>
    </dl>
    <p class="mt-2 text-xs text-gray-500">The auth cookie is HttpOnly and its value cannot be inspected from the browser; this reflects whether a server-side session check succeeded.</p>
  </div>

  <div id="back-to-sign-in-action" class="mt-auto">
    <fdk-button id="back-to-sign-in-button" type="button" variant="secondary" width="full" (click)="backToSignIn()">
      Back to Sign In
    </fdk-button>
  </div>
</div>
